<template>
  <div class="file-select">
    <label class="file-select__label">
      <button @click.prevent="selectFile()" class="file-select__btn">
        <i class="icon icon--attachment"></i>
        <span v-if="fileInput">{{ fileInput.name }}</span>
        <span v-else>Valitse tiedosto</span>
      </button>
      <input
        class="hidden-input"
        type="file"
        ref="fileInput"
        @change="handleFileChange"
      />
    </label>
    <span v-if="hasError" class="error">{{ hasError }}</span>
    <progress
      v-if="status === 'upload'"
      max="100"
      :value="progressValue"
      class="progress-bar"
    ></progress>
  </div>
</template>

<script>
import firebase from "firebase";

export default {
  name: "FileSelect",
  props: {
    action: String,
    hasError: {
      type: String,
      required: false
    },
    folder: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      progressValue: 0,
      status: "init",
      fileInput: null
    };
  },
  watch: {
    action: function(newValue, oldValue) {
      console.log(`action changed from ${oldValue} to ${newValue}`);
      switch (newValue) {
        case "upload":
          console.log("Upload file");
          if (!this.fileInput) {
            console.error("");
          }
          this.status = "upload";
          this.uploadFile();
          break;
        default:
          break;
      }
    }
  },
  methods: {
    selectFile() {
      const el = document.querySelector(".hidden-input");
      el.click();
    },
    handleFileChange() {
      const fileInput = this.$refs.fileInput.files[0];

      this.fileInput = fileInput;
      this.$emit("status-updated", {
        status: "ready_for_upload"
      });
    },
    uploadFile() {
      const _this = this;
      const storageFolder = this.folder;
      const timestamp = new Date().getTime();
      const fileInput = this.$refs.fileInput.files[0];

      const storageRef = firebase.storage().ref();
      const fileRef = storageRef.child(
        `${storageFolder}${timestamp}-${fileInput.name}`
      );

      const uploadFile = fileRef.put(fileInput);

      uploadFile.on(
        "state_changed",
        snapshot => {
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log("Upload is " + progress + "% done");
          _this.progressValue = progress;
        },
        err => {
          console.log("Upload error ", err);
          _this.$emit("status-updated", {
            status: "error",
            error: "Lataus epäonnistui! Yritä uudestaan."
          });
        },
        () => {
          uploadFile.snapshot.ref
            .getDownloadURL()
            .then(fileUrl => {
              console.log("File available at ", fileUrl);
              _this.$emit("status-updated", {
                status: "upload_complete",
                url: fileUrl
              });
            })
            .catch(err => {
              console.log("getDownloadURL error", err);
              _this.$emit("status-updated", {
                status: "error",
                error: "Tiedoston URL:n haku epäonnistui."
              });
            });
        }
      );
    }
  }
};
</script>

<style lang="scss">
.file-select {
  display: flex;
  flex-direction: column;
  margin: 0.5em 0 0;
  i {
    width: 1.5em;
    height: 1.5em;
    margin-right: 1em;
  }
  &__btn {
    display: flex;
    flex-direction: row;
    align-items: center;
    color: $lightred;
    font-size: 1.4rem;
    padding-bottom: 5px;
    outline: none;
    border: none;
    cursor: pointer;
  }
  input[type="file"] {
    display: none;
  }
}
.progress-bar {
  -webkit-appearance: none;
  appearance: none;
  padding: 0 2.5em;
  height: 2px;
  width: 100%;

  &::-webkit-progress-bar {
    background: $gray;
    border-radius: 2.5em;
    overflow: hidden;
  }

  &::-webkit-progress-value {
    background: $lightred;
    transition: $transition;
  }
}
</style>
